import React from 'react'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import CardsGranularSteps from './CardsGranularSteps'
import LcElemensCard from '../../../../card/LcElemensCards'
import CurriculumElementsCards from '../../../../card/CurriculumElementsCards'

const FormGranularSteps = ({ onChangeAlert, type }) => {
  const formLcs = useSelector((state) => state?.dr?.form?.lcs || [])
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})

  return (
    <Box className='absolute top-20 bottom-0 inset-x-0 overflow-auto'>
      <div className={
        ['py-1 flex flex-col gap-1', formLcs.length > 3 ? 'w-fit' : 'w-auto']
        .join(' ')
      }>
        <CardsGranularSteps type={type} lcs={formLcs || []} onChangeAlert={onChangeAlert} />
        <LcElemensCard currentCurriculum={currentCurriculum} lcs={formLcs || []} />
        <CurriculumElementsCards currentCurriculum={currentCurriculum} lcs={formLcs || []} />
      </div>
    </Box>
  )
}

export default FormGranularSteps